import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { AdvanceVectoringUserService } from "app/analytic/advance-vectoring-user.service";
import { ApiService } from "app/modules/shared/services/api.service";
import * as moment from "moment";
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import { ActivatedRoute, Router } from "@angular/router";
import { CryptoService } from "app/shared/utils/crypto.service";

interface UsageAnalytics {
  value: string;
  viewValue: string;
}
@Component({
  selector: "app-basic-vectoring-users-mission",
  templateUrl: "./basic-vectoring-users-mission.component.html",
  styleUrls: ["./basic-vectoring-users-mission.component.scss"],
})
export class BasicVectoringUsersMissionComponent implements OnInit, OnDestroy {
  //********************* SG-7145 start *******************

  userName: string;
  userDetail: any;
  dataSource: MatTableDataSource<any>;
  dateInfo: any;
  subSink: Subscription;
  selectedApp: any;
  dateType: { type: string; from: string; to: string; count: number };
  startDate: string;
  endDate: string;
  displayedColumns: string[] = ["levelType", "sessionsPlayed", "excellentHits", "goodHits", "missedHits", "voiceCommands", "textCommands", "clearedCount", "notClearedCount", "percentageCorrect"];
  pageSize: number = 5;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(HighchartsComponent, { static: false }) highchartsComponent: HighchartsComponent;
  sessionPlayedChartDatasets: { data: any; label: string }[];
  usageType: any = "All";
  updateChart = false;
  totalLessionsSessions = 7;
  sessionPlayedChartLabels: any[];

  usageEramAnalytics: UsageAnalytics[] = [
    { viewValue: "All", value: "All" },
    { viewValue: "Average Lessons Duration", value: "AvgSessionDuration" },
    { viewValue: "Total Lessons Sessions", value: "TotalSessions" },
    { viewValue: "Total Cleared Lessons", value: "ClearedSessions" },

    { viewValue: "Total Not Cleared Lessons", value: "FailedSessions" },
    { viewValue: "Total Voice Commands", value: "VoiceCommands" },
    { viewValue: "Total Text Commands", value: "TextCommands" },
  ];
  usageAnalyticsSelectedValue: string = "All";
  gameType: string;
  lessonRecords: any;
  graphAPIResponse: ArrayBuffer;
  header: any;
  constructor(private crypto: CryptoService, private advanceVectoringService: AdvanceVectoringUserService, private api: ApiService, private router: Router, private activeRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.header = this.activeRoute.snapshot.params.missionName;
    this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
    this.gameType = this.selectedApp.lessonType.replace("[", "%5B").replace("]", "%5D");
    this.userName = localStorage.getItem("nickName");

    this.dateInfo = JSON.parse(localStorage.getItem("dateRange"));
    this.subSink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      this.updateChart = false;
      if (next) {
        this.dateType = { type: "", from: "", to: "", count: 0 };
        if (this.dateInfo) {
          next = this.dateInfo;
        }

        this.dateType.type = next.type ? next.type.toLowerCase() : "day";
        this.dateType.from = next.from ? next.from : moment(new Date()).format("YYYY-MM-DD");
        this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, "days");
        this.dateType.count = next.count ? next.count : 30;
        this.startDate = moment(next.startDate).format("YYYY-MM-DD");
        this.endDate = moment(next.endDate).format("YYYY-MM-DD");
        this.getLessonWiseSessions();
        this.getMissionWiseBasicVectoringGraph();
      }
    });
    this.getUserDetails();
  }

  async getUserDetails() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.advanceVectoringService.getUserDetails(nameStr, this.selectedApp.id).subscribe(async (success) => {
      if (success && success[0]) {
        this.userDetail = success[0];

        if (this.userDetail.email) {
          this.userDetail.emailDec = await this.crypto.decryptData(this.userDetail.email);
        }

        if (this.userDetail.username) {
          this.userDetail.usernameDec = await this.crypto.decryptData(this.userDetail.username);
        }

        this.userDetail.nameIcon = success[0].userRole == "Guest" ? success[0].username.substring(0, 2) : success[0].firstName.split("")[0] + success[0].lastName.split("")[0];
      } else {
        this.userDetail.userDetailsMessage = "No data found";
      }
    });
  }

  async getLessonWiseSessions() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.advanceVectoringService.getBasicLessonWiseData(this.dateType.type, this.gameType, nameStr, this.startDate, this.endDate).subscribe((response) => {
      this.lessonRecords = response;
      this.dataSource = new MatTableDataSource(this.lessonRecords);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  async exportCsvData(usage) {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    if (usage == "performance") {
      this.advanceVectoringService.downLoadLessonWiseRecords(this.dateType.type, this.gameType, nameStr, this.startDate, this.endDate).subscribe((data) => {
        let dataObject: any = data;
        if (data.type === "application/zip") {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
        } else {
          var blob = new Blob([data], { type: "application/csv" });
          FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
        }
      });
    } else {
      this.advanceVectoringService.downLoadLessonWiseGraph(this.dateType.type, this.gameType, nameStr, this.usageType, this.startDate, this.endDate).subscribe((data) => {
        if (data.type === "application/zip") {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
        } else {
          var blob = new Blob([data], { type: "application/csv" });
          FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
        }
      });
    }
  }

  changeAnalytics(event) {
    this.usageType = event;
    this.updateChart = false;
    this.getMissionWiseBasicVectoringGraph();
  }

  async getMissionWiseBasicVectoringGraph() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.advanceVectoringService.getUserwiseBasicVectoringGraph(this.dateType.type.toLowerCase(), this.gameType, nameStr, this.usageType, this.startDate, this.endDate).subscribe((response) => {
      this.graphAPIResponse = response;
      this.getGraphConfiguration();
    });
  }

  getGraphConfiguration() {
    if (this.dateType.type == "day") {
      this.dateType = { type: "day", from: moment(new Date()).format("YYYY-MM-DD"), to: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"), count: 30 };

      this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.dateType);
    } else if (this.dateType.type == "month") {
      this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.dateType.from);
    } else if (this.dateType.type == "year") {
      this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.dateType.from);
    } else if (this.dateType.type == "range") {
      let selectedFromDate = this.startDate;
      let selectedEndDate = this.endDate;
      this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(selectedFromDate, selectedEndDate);
    }
    let AvgSessionDuration = this.graphAPIResponse[0].AvgSessionDuration ? this.graphAPIResponse[0].AvgSessionDuration.map((v) => Number(v)) : this.graphAPIResponse[0].AvgSessionDuration;
    let ClearedSessions = this.graphAPIResponse[0].ClearedSessions ? this.graphAPIResponse[0].ClearedSessions.map((v) => Number(v)) : this.graphAPIResponse[0].ClearedSessions;
    let FailedSessions = this.graphAPIResponse[0].FailedSessions ? this.graphAPIResponse[0].FailedSessions.map((v) => Number(v)) : this.graphAPIResponse[0].FailedSessions;
    let TextCommands = this.graphAPIResponse[0].TextCommands ? this.graphAPIResponse[0].TextCommands.map((v) => Number(v)) : this.graphAPIResponse[0].TextCommands;
    let TotalSessions = this.graphAPIResponse[0].TotalSessions ? this.graphAPIResponse[0].TotalSessions.map((v) => Number(v)) : this.graphAPIResponse[0].TotalSessions;
    let VoiceCommands = this.graphAPIResponse[0].VoiceCommands ? this.graphAPIResponse[0].VoiceCommands.map((v) => Number(v)) : this.graphAPIResponse[0].VoiceCommands;

    this.sessionPlayedChartDatasets = [];

    if (this.usageType == "All" || this.usageType == "AvgSessionDuration") {
      this.sessionPlayedChartDatasets.push({ data: AvgSessionDuration, label: "Average Lessons Duration" });
    }
    if (this.usageType == "All" || this.usageType == "TotalSessions") {
      this.sessionPlayedChartDatasets.push({ data: TotalSessions, label: "Total Lessons Sessions" });
    }
    if (this.usageType == "All" || this.usageType == "ClearedSessions") {
      this.sessionPlayedChartDatasets.push({ data: ClearedSessions, label: "Total Cleared Lessons" });
    }
    if (this.usageType == "All" || this.usageType == "FailedSessions") {
      this.sessionPlayedChartDatasets.push({ data: FailedSessions, label: "Total Not Cleared Lessons" });
    }
    if (this.usageType == "All" || this.usageType == "VoiceCommands") {
      this.sessionPlayedChartDatasets.push({ data: VoiceCommands, label: "Total Voice Commands" });
    }
    if (this.usageType == "All" || this.usageType == "TextCommands") {
      this.sessionPlayedChartDatasets.push({ data: TextCommands, label: "Total Text Commands" });
    }

    const timepointPlayed = this.graphAPIResponse?.[0]?.["Timepoint"];
    if (timepointPlayed) {
      if (this.dateType.type == "day") {
        this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
      } else if (this.dateType.type == "month") {
        this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
      } else if (this.dateType.type == "year") {
        this.sessionPlayedChartLabels = timepointPlayed;
      } else if (this.dateType.type == "range") {
        this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
      }
    }

    this.updateChart = true;
    this.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
    this.dateInfo = undefined;
  }

  updateChartData(label: string[], dataset: any) {
    this.highchartsComponent.updateChartData(label, dataset);
  }

  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i <= data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === "month" || data.type === "Month") {
        const selectedMonth = moment(date).subtract(i, "months");
        daysDate.push(moment(selectedMonth).format("MMM YYYY"));
      } else if (data.type === "year" || data.type === "Year") {
        var selectedYear = moment(date).subtract(i, "years");
        daysDate.push(moment(selectedYear).format("YYYY"));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format("ddd, MMM D"));
      }
    }
    return daysDate.reverse();
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, "months");
      months.push(moment(selectedMonth).format("MMM YYYY"));
    }
    return months.reverse();
  }

  getLastFiveYearsDefault(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, "years");
      years.push(moment(selectedYear).format("YYYY"));
    }
    return years.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }
  
  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1);
  
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      });
  }
  
  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, day, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1, day);
  
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
      });
  }
  
  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
  }
  //**************  SG-7218 start *****************

  openLevelPopUP(element) {
    let missionData = localStorage.getItem("selectedApp");
    let selectedApp = JSON.parse(missionData);
    let appData = { ...selectedApp, levelType: element.levelType, lessonType: element.lessonType };
    localStorage.setItem("selectedApp", JSON.stringify(appData));
    this.router.navigate(["main/user/details/basic/levelwise", this.userName, element.levelType]).then(() => {
      this.api.addRoute(0, element.levelType);
    });
  }
  //**************  SG-7218 end *****************
}
//********************* SG-7145 end *******************
